import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import { Zoom } from "react-reveal";
import { ShowEntertainments } from "../../API/EntertainmentAPI";
import { ShowMaintenances } from "../../API/MaintenanceAPI";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import ModalMaintenance from "./ModalMaintenance";
import Search from "../../Components/Search";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import help from "../../assets/images/help.png";
import { useBusinessNameContext } from "./../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import useMixpanel from "../../hooks/useMixpanel";
const business_name = localStorage.getItem("business_name");

function Maintenances() {
  const { businessName, setBusinessName } = useBusinessNameContext();
  const { track } = useMixpanel();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const euuid = rawPath.split("categories/")[1];
  const navigate = useNavigate();
  const params = useParams();
  const lang = sessionStorage.getItem("lang");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState();
  const [category, setCategory] = useState();
  const [textMod, setTextMod] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  // const handleClose = () => setShow(false);
  const handleShow = (id, text, category) => {
    // console.log("id", id, "color:green");
    setCategory(id);
    setTextMod(text);
    setShow(true);
    setSelectedCategory(category);
  };
  const { t, i18n } = useTranslation();
  // console.log("category", category);
  let flowers;
  let bgColor;
  let color;
  let text;
  let company_id;
  let entertainmentCategories;
  const { data, isLoading, error } = ShowMaintenances(
    room_uuid,
    params.uuid,
    lang,
  );
  if (!isLoading) {
    if (error) {
      if (error?.response.status == 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.status === false || data.data.success === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        flowers = data.data.data;
        entertainmentCategories = flowers.maintenance.services;
        company_id = flowers.maintenance.id;
        bgColor = flowers.header_color;
        text = flowers.title;

        // console.log("ShowEntertainmentss", flowers);
      }
    }
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  // useEffect(() => {
  //   const getData = async () => {
  //     setLoading(true)
  //     axios
  //       .get(
  //         `/${room_uuid}/entertainment/categories/1bb893d8-e5b0-42ba-a684-7f563c2e8ca5`
  //       )
  //       .then((res) => {
  //         const data = res.data.data;
  //         setEntertainmentCategories(data.entertainment_categories);
  //         setTitle(data?.title)
  //         console.log("data,entertainment/companies", data);
  //         setLoading(false)
  //       });
  //   };
  //   getData();
  // }, []);

  const handleNavigatePdf = (pdf, name) => {
    navigate(`/${room_uuid}/pdf-viewer?pdf=${pdf}&name=${name}`);
  };

  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
      <main
        className="home-main bg-white maintenances mb-0 min-height-0"
        style={{ paddingTop: "80px" }}
      >
        <Search
          placeholder="Search for Categories..."
          room_uuid={room_uuid}
          category="Maintenance"
        />

        <div className="display-list three-items v2 v3  ">
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <CustomBusinessServiceLoader
                businessName={businessName}
                loader={"spa"}
              />
            </div>
          ) : businessName === "The Lana Residences Dubai" ? (
            // Render static staff if business_name matches
            <>
              <li
                onClick={() =>
                  handleNavigatePdf(
                    encodeURIComponent(
                      "https://tdhbucket.s3.me-central-1.amazonaws.com/lana_pdfs/OBS-+AMC+Packages+and+Services.pdf",
                    ).replace(/\+/g, "%2B"),
                    "AMC Packages",
                  )
                }
              >
                <Zoom>
                  <a>
                    <div className="img-pnl"></div>
                    <img
                      src={
                        "https://tdhbucket.s3.me-central-1.amazonaws.com/business_services/15.png"
                      }
                      alt="AMC Packages"
                    />
                    <div className="bg-layer"></div>
                  </a>
                  <p>AMC Packages</p>
                </Zoom>
              </li>
              <li
                id="staff2"
                onClick={() =>
                  handleNavigatePdf(
                    `https://tdhbucket.s3.me-central-1.amazonaws.com/lana_pdfs/OBS-Annual+Maintenance-+FAQ's+v2.pdf`,
                    "FAQs",
                  )
                }
              >
                <Zoom>
                  <a>
                    <div className="img-pnl"></div>
                    <img src={help} />
                    <div className="bg-layer"></div>
                  </a>
                  <p>FAQs</p>
                </Zoom>
              </li>
            </>
          ) : businessName !== "The Lana Residences Dubai" &&
            entertainmentCategories ? (
            entertainmentCategories.map((x, idx) => {
              const serviceName = x.service_name || x.name;
              const serviceIcon = x.image || flowers?.maintenance?.icon;
              return (
                <li
                  id={x.id}
                  key={x.id || idx}
                  onClick={() => {
                    handleShow(x.service_id ?? x.id, serviceName, x);
                    track.menuItemViewed({
                      item_id: x.id,
                      item_name: serviceName,
                      category_name: "Maintenance",
                      price: 0,
                    });
                  }}
                >
                  <Zoom>
                    <a onClick={() => handleShow(x.service_id ?? x.id, serviceName, x)}>
                      <div className="img-pnl"></div>
                      <img src={serviceIcon} alt="" />
                      <div></div>
                      <div className="bg-layer"></div>
                    </a>
                    <p>{serviceName}</p>
                  </Zoom>
                </li>
                // <li id={x.name} key={idx}>
                //   <Zoom>
                //     <div
                //       className="con-img-container v3"
                //       onClick={(id) => handleShow(x.id, x.image)}
                //     >
                //       <div className="con-img">
                //         <img src={x.image} alt="" />
                //         <p></p>
                //       </div>
                //     </div>
                //     <div className="con-text-container">
                //       <p>{x.name}</p>
                //       <hr className="mb-0 dark" />
                //     </div>
                //   </Zoom>
                // </li>
              );
            })
          ) : null}
        </div>
      </main>
      {theme && <NewFooter />}
      <ModalMaintenance
        show={show}
        setShow={setShow}
        category={category}
        room_uuid={room_uuid}
        text={textMod}
        company_id={company_id}
        theme={theme}
        selectedCategory={selectedCategory}
        requiredFields={{
          nameRequired: flowers?.name_required,
          emailRequired: flowers?.email_required,
          phoneRequired: flowers?.phone_required,
        }}
      />
    </div>
  );
}
export default Maintenances;
